import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "ui/Button";
import {
  CustomPropertyInputItem,
  CustomPropertySelect,
} from "ui/CustomProperty";
import { CPAllocationTypeProps } from "../types";
import { SelectOptionType } from "../../select/Select";
import {
  defaultPercentOptions,
  widgetPercentOptions,
} from "../../../../infrastructure/constants/PercentOptions";
import { getNextKey } from "app/utils";
import SvgIcon from "../../svg-icon/SvgIcon";
import CostCenterPercentAutocomplete from "../../autocomplete/CostCenterPercentAutocomplete";

const AllocationCustomProp: React.FC<CPAllocationTypeProps> = ({
  id,
  name,
  codeName,
  required,
  permissions,
  isWidget,
  tabIndex,
  readOnly,
  changeable,
  keyId,
  onChange,
  value,
  onChangeDependency,
  customPropertyId,
  parentKey,
  values,
  defaultValue,
}) => {
  const { t } = useTranslation();

  const [percentOptions] = useState(
    isWidget ? widgetPercentOptions : defaultPercentOptions
  );
  const [option, setOption] = useState<SelectOptionType[]>([]);

  const addRow = () => {
    const newValue = value?.length ? [...value] : [];
    const newRow = {
      key: `${id}-${getNextKey("CPAllocation")}`,
      value: 0,
      text: "",
      percent: !value.length ? 100 : 0,
      customPropertyCode: codeName,
      customPropertyId: String(customPropertyId),
    };
    newValue.push(newRow);
    onChange(newValue, undefined, false, undefined, true, newRow);
  };

  const deleteRow = async (rowId: string) => {
    const newValue = value.filter((item) => item.key !== rowId);
    onChange(newValue, undefined, false, rowId);
  };

  const handleChangeSelect = async (
    option: SelectOptionType,
    row: SelectOptionType
  ) => {
    let changedValue;
    const newValue = value.map((item) => {
      if (item.key !== row.key) {
        return item;
      } else {
        changedValue = {
          ...item,
          value: Number(option.value),
          text: option.text,
          validSelect: true,
        };
        return changedValue;
      }
    });
    onChange(newValue, undefined, false, undefined, false, changedValue);
  };

  const handleChangePercent = (option: string, row: SelectOptionType): void => {
    const newValue = value.map((item: SelectOptionType) =>
      item.key === row.key
        ? { ...item, percent: Number(option), validPercent: true }
        : item
    );
    onChange(newValue, undefined, true);
    //validate(newValue);
  };

  const isDisabled =
    (isWidget && !changeable) ||
    !permissions.includes(`CustomProperty_${codeName}`);

  useEffect(() => {
    setOption(values);
  }, [values, defaultValue]);

  return (
    <>
      {value?.length &&
        value.map((item: SelectOptionType, index: number) => (
          <div
            key={item.key}
            className="input-item-row d-flex"
            style={{ gap: "0.875rem" }}
          >
            <CustomPropertyInputItem
              //  valid={item.validSelect}
              name={`${name} ${index + 1}`}
              required={required}
            >
              <CustomPropertySelect
                isWidget={!!isWidget}
                name={name}
                keyId={keyId}
                options={option}
                handleChange={(opt) => handleChangeSelect(opt, item)}
                defaultValue={item}
                readOnly={readOnly}
                disabled={isDisabled}
                tabIndex={tabIndex}
              />
            </CustomPropertyInputItem>
            <CustomPropertyInputItem
              //  valid={validPercent && item.validPercent}
              disabled={isDisabled}
              name={`${t("custom_property.allocation.percent")} ${index + 1}`}
              required={required}
              isLittle
              inputStyle={{ width: "20%" }}
            >
              <CostCenterPercentAutocomplete
                onChoose={(opt) => handleChangePercent(opt, item)}
                defaultText={item.percent ? item.percent.toString() : ""}
                options={percentOptions}
                readOnly={readOnly}
                disabled={isDisabled}
                tabIndex={tabIndex}
                isWidget={isWidget}
              />
            </CustomPropertyInputItem>
            {value.length > 1 && !readOnly && changeable && (
              <div
                className={`flex align-items-center ${
                  isDisabled ? " disabled" : ""
                }`}
                style={{ width: "22px" }}
              >
                <SvgIcon
                  className="icon icon-remove"
                  href="#svg_icon_remove"
                  type={"delete"}
                  onClick={() => deleteRow(item.key as string)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            )}
          </div>
        ))}

      <div className="input-item-row">
        <div className="cost-centers">
          {!isDisabled && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                buttonWidth="199px"
                iconId="plus"
                onClick={addRow}
                buttonColor="gray"
                buttonText={t("custom_property.allocation.add", {
                  property: name.toLowerCase(),
                })}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AllocationCustomProp;
